import React from "react"
import DeleteOutlineIcon from '@mui/icons-material/DeleteOutline';
import Tooltip from '@mui/material/Tooltip';
import IconButton from '@mui/material/IconButton';
import swal from "sweetalert";
import { softDeleteNotesData } from "../../../services/api/apiHandler";
import { socket } from "../../../services/socket/socket";
import { useDispatch } from "react-redux";
import { clearSoftDeleteNotes } from "../../../redux/actions/TemplateTabs/actionDN";
import { Delete } from "@material-ui/icons";

import { ReactComponent as DeleteIcon} from "../../../myfin_v2/assets/icons/delete_icon_primary.svg";
import Modal from "../../../../src/myfin_v2/elements/Modal";
import modalcss from "../../../../src/myfin_v2/css/modal.module.css";
import { ReactComponent as DeleteIconWhite } from "../../../myfin_v2/assets/icons/delete.svg";
import { ReactComponent as CloseIcon } from "../../../myfin_v2/assets/icons/close.svg";
import  { useState, useEffect, useContext } from "react";
import buttoncss from "../../../myfin_v2/css/button.module.css";
import { Button } from "../../../myfin_v2/elements/Button";



const NoteSoftDelete = (props) => {
    const user = JSON.parse(localStorage.getItem('user'));
    const { softDeletedData, setDeleteItemsModal } = props;
    const project_id = localStorage.getItem("project_id");
    const tb_id = localStorage.getItem("tb_id");
    const dispatch = useDispatch();

    
    
    const handleSoftDelete = () => {
        const payload = {
            "selectedNotes": softDeletedData
        }

        softDeleteNotesData(project_id, payload).then(()=> {
            socket.emit("request-mapped-grouping", {project_id, tb_id});
            socket.emit("request-balance-sheet", {project_id, tb_id})
            socket.emit("request-pnl-statement", {project_id, tb_id});
            socket.emit("request-fetch-console-notes", { pid: project_id });
            dispatch(clearSoftDeleteNotes());
        }).catch((err)=>{
            swal("Error!", err.message, "error", {
                button: "OK",
            });
        })
    }

    const handleClick = () => {
        // swal({
        //     title: "Are you sure to delete the notes?",
        //     text: "you can still restore the deleted note!",
        //     icon: "warning",
        //     buttons: true,
        //     dangerMode: true,
        //   })
        //   .then((willDelete) => {
        //     if (willDelete) {
        //       handleSoftDelete();
        //       swal("Poof! Selected Notes has been deleted!", {
        //         icon: "success",
        //       });
        //     }
        //   });
        setDeleteItemsModal(true);
       
    }

    return (
        <Tooltip title="Notes Soft Delete">
            {/* <IconButton onClick={handleClick} disabled={user.responsibilities === "approver" || user.responsibilities === "view"}>
                <DeleteOutlineIcon/>
            </IconButton> */}
             <DeleteIcon onClick={handleClick} disabled={user.responsibilities === "approver" || user.responsibilities === "view"}>
                {/* <DeleteOutlineIcon/> */}
            </DeleteIcon>
             
        </Tooltip>
    )
}


export default NoteSoftDelete